import React from "react";

import Content from "src/components/MyEvents/Content/Content";

const MyEvents = () => {
  return <Content />;
};

export default MyEvents;
